/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Etaf_Not_Ready_For_ApprovalInputs */

const en_error_etaf_not_ready_for_approval = /** @type {(inputs: Error_Etaf_Not_Ready_For_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The form is not complete enough to be approved.`)
};

/**
* | output |
* | --- |
* | "The form is not complete enough to be approved." |
*
* @param {Error_Etaf_Not_Ready_For_ApprovalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_etaf_not_ready_for_approval = /** @type {((inputs?: Error_Etaf_Not_Ready_For_ApprovalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Etaf_Not_Ready_For_ApprovalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_etaf_not_ready_for_approval(inputs)
});